<template>
  <div>
    <div style="width:100%;height:400px;" v-bind:id="id"></div>
  </div>
</template>

<script>
import chartResize from '@/mixin/chart-resize'
import { getUUID } from '../../utils/util'
let unwatch
export default {
  mixins: [chartResize],
  name: 'NestedRing',
  components: {},
  data() {
    return {
      id: getUUID()
    }
  },
  props: {
    data: {
      type: Object
    },
    total: {
      type: Number
    }
  },
  myChart: null,
  methods: {
    set(data) {
      var option
      option = {
        tooltip: {
          trigger: 'axis'
        },
        grid: data.grid,
        color: data.color,
        title: data.title
          ? data.title
          : {
              subtext: ' m³'
            },
        xAxis: {
          type: 'category',
          data: data.xdata,
          axisLabel: {
            rotate: 30,
            margin: 8,
            formatter: function(params) {
              // var val = ''
              // if (params.length > 3) {
                // val = params.substr(5,9)
                // return val
              // } else {
                return params
              // }
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          }
        },
        series: [
          {
            data: data.sdata,
            type: 'line',
          }
        ]
      }

      this.myChart.setOption(option)
      // window.addEventListener('resize', function() {
      //   this.myChart.resize()
      // })
    },
    drawRingGraph(id) {
      let _this = this
      this.myChart = echarts.init(document.getElementById(id))

      unwatch = this.$watch(
        'data',
        function(newvalue, oldvalue) {
          if (newvalue) {
            console.log(newvalue, 'newvalue')
            this.set(newvalue)
          }
        },
        { deep: true, immediate: true }
      )
    }
  },
  mounted() {
    this.drawRingGraph(this.id)
  },
  created() {},
  beforeDestroy() {
    if (unwatch) {
      unwatch()
      unwatch = null
    }
    if (!this.myChart) {
      this.myChart.dispose()
      this.myChart = null
    }
  }
}
</script>
<style lang="less" scoped>
</style>
